/* @ngInject */
function HeaderRepositoryController ($scope) {
  const api = {

  }
  this.getApi = () => api

  $scope.onAdvancedFilter = filters => {
    $scope.toolbar.search.onFilter(filters)
  }

  $scope.onSearchAdvanced = search => {
    const { searchTerm, tags } = search
    $scope.toolbar.search.onSearch(searchTerm, tags)
  }

  $scope.onSearchAssetClick = asset => {
    $scope.toolbar.search.onSearchAssetClick(asset)
  }

  $scope.onSearch = (event) => {
    const searchTerm = event.detail.value
    $scope.toolbar.search.onSearch(searchTerm)
  }

  $scope.onSearchChange = (event) => {
    const searchTerm = event.detail.value
    if (!searchTerm) {
      $scope.toolbar.search.onSearch(searchTerm)
    }
  }

  $scope.onBreadcrumbsChange = (event) => {
    $scope.breadcrumbs.onChange(event.detail)
  }

  $scope.onButtonClick = (event, button) => {
    if (button.pricing) {
      button.onClick(event)
    } else {
      button.onClick()
    }
  }

  $scope.checkButtonIsLoading = (button) => {
    if (typeof button.isLoading === 'function') {
      return button.isLoading()
    }

    return Boolean(button?.isLoading)
  }
}

export { HeaderRepositoryController }
